import { AxiosInstance } from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { endOfDay, format } from "date-fns";
import * as requestUrl from "../../constants/request";

import { FilterProps } from "store/common";
import { FetchPaymentActivityResult } from "./paymentActivity-state";

const constructPaymentActivityUrl = (
  {
    minDate,
    maxDate,
    paymentMethodType,
    status,
    pageNumber,
    pageSize,
    sortColumn,
    sortDir,
    confirmationNumber,
    accountNumber,
    excludeErrorStatus = false,
  }: Partial<FilterProps> = {},
  paymentActivityUrl: URL
): URL => {
  if (!!minDate) {
    paymentActivityUrl.searchParams.append("minDate", minDate);
  }
  if (!!maxDate) {
    paymentActivityUrl.searchParams.append(
      "MaxDate",
      format(endOfDay(new Date(maxDate)), "yyyy-MM-dd HH:mm:ss")
    );
  }
  if (!!confirmationNumber) {
    paymentActivityUrl.searchParams.append(
      "confirmationNumber",
      confirmationNumber
    );
  }
  if (paymentMethodType !== undefined && paymentMethodType !== null) {
    paymentActivityUrl.searchParams.append(
      "PaymentMethodType",
      paymentMethodType.toString()
    );
  }
  if (!!accountNumber) {
    paymentActivityUrl.searchParams.append("accountNumber", accountNumber);
  }
  if (status !== undefined && status !== null) {
    paymentActivityUrl.searchParams.append("Status", status.toString());
  }
  if (pageSize !== undefined && pageSize !== null) {
    paymentActivityUrl.searchParams.append("PageSize", pageSize.toString());
  } else {
    paymentActivityUrl.searchParams.append("PageSize", "10");
  }
  if (pageNumber !== undefined && pageNumber !== null) {
    paymentActivityUrl.searchParams.append("PageNum", pageNumber.toString());
  } else {
    paymentActivityUrl.searchParams.append("PageNum", "1");
  }
  if (sortColumn !== undefined && sortColumn !== null) {
    paymentActivityUrl.searchParams.append("SortColumn", sortColumn.toString());
  }
  if (sortDir !== undefined && sortDir !== null) {
    paymentActivityUrl.searchParams.append("SortDir", sortDir.toString());
  }
   paymentActivityUrl.searchParams.append("excludeErrorStatus", excludeErrorStatus.toString()
  );
  return paymentActivityUrl;
};

export type FetchPayments = typeof fetchPayments;

export const fetchPayments = createAsyncThunk<
  FetchPaymentActivityResult,
  {
    request: AxiosInstance;
    data: FilterProps;
  }
>("paymentActivity/fetchPayments", async ({ request, data }) => {
  let paymentActivityUrl = new URL(
    requestUrl.FT_PAYMENT_ACTIVITY,
    requestUrl.FT_REQUEST_BASE_URL
  );

  paymentActivityUrl = constructPaymentActivityUrl(data, paymentActivityUrl);

  const paData = await request(paymentActivityUrl.toString());

  return paData.data;
});

export type FetchPendingPayments = typeof fetchPendingPayments;

export const fetchPendingPayments = createAsyncThunk<
  FetchPaymentActivityResult,
  {
    request: AxiosInstance;
    data: FilterProps;
  }
>("paymentActivity/fetchPendingPayments", async ({ request, data }) => {
  let paymentActivityUrl = new URL(
    requestUrl.FT_PAYMENT_ACTIVITY,
    requestUrl.FT_REQUEST_BASE_URL
  );

  paymentActivityUrl = constructPaymentActivityUrl(data, paymentActivityUrl);
  const paData = await request(paymentActivityUrl.toString());
  return paData.data;
});
